import { render, staticRenderFns } from "./medicalAestheticsAssets.vue?vue&type=template&id=2cee54a0&scoped=true&"
import script from "./medicalAestheticsAssets.vue?vue&type=script&lang=js&"
export * from "./medicalAestheticsAssets.vue?vue&type=script&lang=js&"
import style0 from "./medicalAestheticsAssets.vue?vue&type=style&index=0&id=2cee54a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee54a0",
  null
  
)

export default component.exports